// extracted by mini-css-extract-plugin
export default {"headerBar":"mN-z","pointsSection":"nN-z","goToDashboard":"oN-z"};